export const CREATE_BOOKING = '/api/CustomerAnalytics/createRetailBooking';
export const GET_ORGANISATION_DETAILS = '/api/CustomerAnalytics/orgdetails';
export const FETCH_CITY_LIST = '/api/customeranalytics/areacode/cities/fetch';
export const FETCH_AREA_CODES = '/api/customeranalytics/areacode/fetch';
export const FETCH_SERVICE_TYPES = '/api/customeranalytics/getServiceTypes';
